import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const stateListFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.stateList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
